// extracted by mini-css-extract-plugin
module.exports = {"partHr":"light-separator-component_partHr__N-c2V"};